module.exports = __webpack_public_path__ + "img/aamcartlogo.3726327d.jpg";